import MessageBanner from './MessageBanner'
import { ACTIVATION_ERROR_CODE_TO_DISPLAY_MSG_MAP } from '../../ErrorCodes'
import type { VFC } from 'react'
import { useEffect, useMemo } from 'react'
import type { BannerProps } from '@panwds/react-ui'


interface ErrorCodeProps {
  errorCode: string
  timerInMilliSec?: number
  callback?: object
  bannerProps?: BannerProps
  doNotCloseBanner?: boolean
}

const ErrorBanner: VFC<ErrorCodeProps> = (errorInfo) => {
  const { timerInMilliSec = 15000, errorCode, callback = {}, bannerProps: _bannerProps, doNotCloseBanner = false } = errorInfo
  const bannerProps: BannerProps = {
    appearance: 'error',
    dataMetrics: 'activation-error-banner',
    dataTestId: 'activation-error-banner',
    showIcon: true,
    type: 'page',
    ..._bannerProps,
  }

  useEffect(() => {
    setTimeout(() => {
      if (typeof callback === 'function') {
        callback()
      }
    }, timerInMilliSec)
  }, [callback, timerInMilliSec])

  const errorMessage = useMemo(() => {
    return ACTIVATION_ERROR_CODE_TO_DISPLAY_MSG_MAP[errorCode] || errorCode
  }, [errorCode])

  return (
    <div>
      {errorMessage && <MessageBanner message={errorMessage} doNotCloseBanner={doNotCloseBanner} bannerProps={bannerProps} timerInMilliSec={timerInMilliSec} />}
    </div>
  )
}

export default ErrorBanner
